// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "dialogRoot-2OjpQ";
var _4 = "dialogContent-2yT2s";
var _5 = "header-lYMTn";
var _6 = "content-Xn_vb";
var _7 = "checkin__status-3vRG8";
var _8 = "button-3iMCx";
var _9 = "onlyAirportCheckinNotification-1jZmY";
var _a = "root-jbB0L";
export { _1 as "__esModule", _2 as "mobile", _3 as "dialogRoot", _4 as "dialogContent", _5 as "header", _6 as "content", _7 as "checkin__status", _8 as "button", _9 as "onlyAirportCheckinNotification", _a as "root" }
export default { "__esModule": _1, "mobile": _2, "dialogRoot": _3, "dialogContent": _4, "header": _5, "content": _6, "checkin__status": _7, "button": _8, "onlyAirportCheckinNotification": _9, "root": _a }
